import React from 'react'
import { NavLink } from 'react-router-dom'
import { BillingProductType, ProgramFeatures } from '@citruscamps/citrus-client'
import { ROUTES } from '../../../constants/routes'
import { useLocalStorage } from '../../../hooks/useLocalStorage'
import { useFlags } from '../hooks/useFlags'

interface IProps {
  flagKey: keyof ProgramFeatures | (keyof ProgramFeatures)[]
  feature: string
  product: BillingProductType
  additionalDetails?: string
  check?: (value?: boolean | number | string, key?: string) => boolean
  checkAll?: (flags: ProgramFeatures) => boolean
}

export const UpgradeMessage = ({
  flagKey,
  feature,
  product,
  additionalDetails,
  check = (val) => !!val,
  checkAll,
  children,
}: React.PropsWithChildren<IProps>) => {
  const { flags } = useFlags()
  const [isMessageDismissed, setIsMessageDismissed] = useLocalStorage<boolean>(
    `upgrade-message-${[feature, product].join('-')}`,
    false,
  )
  const isEnabled: boolean =
    !!flags &&
    (checkAll
      ? checkAll(flags)
      : Array.isArray(flagKey)
      ? flagKey.every((flagKey) => check(flags[flagKey], flagKey))
      : check(flags[flagKey], flagKey))
  if (isEnabled || isMessageDismissed) {
    return null
  }
  return (
    <div
      className={`alert alert-warning alert-dismissible fade${
        !isMessageDismissed ? 'show' : ''
      } my-3`}
      role="alert"
    >
      {children || (
        <>
          In order to manage {feature.toLowerCase()}, we require you to upgrade to a{' '}
          <b className="text-capitalize">{product}</b> plan.
          {additionalDetails ? ` ${additionalDetails} ` : ' '}
        </>
      )}
      <NavLink to={ROUTES.BILLING_SETTINGS}>Click here to update your plan</NavLink>
      <button
        type="button"
        className="btn-close"
        data-bs-dismiss="alert"
        aria-label="Close"
        onClick={() => setIsMessageDismissed(true)}
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  )
}
